import React from 'react';
import { IconButton } from '@paypalcorp/pp-react';
import { closeWindow, isInContext } from '../utility/inContextDonation';
import TemplateData from '../utility/getTemplateData';
import * as FPT from '../utility/fpt';
import { getDismissEventName } from '../utility/externalIntegrationUtils';
import { localsMessages } from '../utility/getTemplateData';
import PropTypes from 'prop-types';

const messages = localsMessages('common/header');

export default function CloseButton({ isDarkButton = false }) {
  const { button } = ({} = messages || {});

  const handleClose = () => {
    FPT.trackLinkClickWithData('cancel', {
      event_name: getDismissEventName(),
    });
    if (isInContext()) {
      closeWindow();
      return;
    }
    window.location.href = TemplateData.charityCancelUrl;
  };

  return (
    <IconButton
      data-testid="close-button"
      iconName="close"
      onClick={handleClose}
      className={`close-button ${isDarkButton ? 'dark' : ''}`}
    >
      {button.close}
    </IconButton>
  );
}

CloseButton.propTypes = {
  isDarkButton: PropTypes.bool,
};
